document.addEventListener('DOMContentLoaded', () => {

  function tryMove() {
    const languageSelector = document.getElementById('languageSelector');
    const duoSelector = document.querySelector('.ht-tms__duo-selector');

    // どちらか無ければまだ移動できない
    if (!languageSelector || !duoSelector) return false;

    // すでに中に入ってたら何もしない（無限ループ防止）
    if (languageSelector.contains(duoSelector)) return true;

    // 移動（remove() は不要。appendChild で自動的に移動される）
    languageSelector.appendChild(duoSelector);
    return true;
  }

  // まず1回試す
  if (tryMove()) return;

  // だめならDOM変化を監視して、出現した瞬間に移動
  const observer = new MutationObserver(() => {
    if (tryMove()) observer.disconnect();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
});
